import { useQuery } from '@tanstack/react-query'
import { listVndlyInstances } from 'api/admin/vndly/listVndlyInstances'
import { vndlyKeys } from './keys'

export function useVndlyInstancesQuery() {
  return useQuery({
    queryKey: vndlyKeys.instances(),
    queryFn: listVndlyInstances,
  })
}
